
console.log('full page script laoded::::::::::::::::::::::::')

// new fullpage('#MainContent', {
//         autoScrolling: true,
//         navigation: true,
//         scrollingSpeed: 700,
//         anchors: ['shopify-section-template--18624612761848__featured-collection','shopify-section-template--18624612761848__slideshow','shopify-section-template--18624612761848__countdown-timer',
//                   'shopify-section-template--18624612761848__image-comparison','shopify-section-template--18624612761848__bundle-products','shopify-section-template--18624612761848__images_with_text_kDzaQz',
//                  'shopify-section-template--18624612761848__video-hero','shopify-section-template--18624612761848__slideshow_ntwapE','shopify-section-template--18624612761848__gallery',
//                   'shopify-section-template--18624612761848__blog_home_F3bDwa','shopify-section-template--18624612761848__guarantees','shopify-section-template--18624612761848__scrolling_promotion_UQmBce'],
//         responsiveWidth: 768,
// });


// window.addEventListener('scroll', function() {
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     const logos = document.querySelectorAll('.template-index  .header__heading-logo.inverse.small-hide, .template-index .header__heading-logo.inverse.medium-hide');
//     const header = document.querySelector('.template-index .shopify-section-header');

//     // Scroll effect range for scaling, opacity reduction, and top positioning
//     const scrollRange = 300;

//     // Apply effect to all logo elements
//     logos.forEach(logo => {
//         // Check if "shopify-section-header-sticky" class is added to .shopify-section-header
//         if (header && header.classList.contains('shopify-section-header-sticky')) {
//             logo.style.transition = 'opacity 1s ease-out, transform 0.4s ease-out, top 0.4s ease-out';
//             logo.style.opacity = '0';  
//             logo.style.transform = 'scale(0.8) translateY(-20px)';  /
//             logo.style.top = '90%';  
//         } else {
//             // On page load and scroll, apply scale, opacity, and top changes to the logo
//             if (scrollTop < scrollRange) {
//                 const scale = Math.max(1, 12.5 - scrollTop / 50);  
//                 const opacity = Math.max(0, 1 - scrollTop / scrollRange);  
//                 const translateY = -scrollTop / 2;  

//                 logo.style.transform = `scale(${scale}) translateY(${translateY}px)`; 
//                 logo.style.opacity = opacity;  
//                 logo.style.top = '300%';  
//                 logo.style.pointerEvents = 'none';  
//             }
//         }
//     });
// });

// // Set the initial state of the logo on page load
// window.addEventListener('load', function() {
//     const logos = document.querySelectorAll('.header__heading-logo.inverse.small-hide, .header__heading-logo.inverse.medium-hide');
    
//     logos.forEach(logo => {
//         // Position the logo in the middle of the page on load
//         logo.style.transition = 'none';  // Disable transition on load for immediate positioning
//         logo.style.transform = 'scale(12.5) translateY(0)';  // Scale to 12.5 and center it
//         logo.style.opacity = '1';  // Make sure it's fully visible
//         logo.style.top = '300%';  // Center it vertically on load
        
//         // Add transition back for scroll effects after load
//         setTimeout(() => {
//             logo.style.transition = 'transform 1s ease-out, opacity 0.6s ease-out, top 0.6s ease-out';
//         }, 100);  // Slight delay to avoid immediate transition on load
//     });
// });

